import {createContext} from 'react';

const LookWizardContext = createContext({}); // check LookWizardHooks.js

// export const lookWizardContextReducer = (state = {}, action) => {
//   return {...state, ...action};
// }

export default LookWizardContext;
